import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import img from "./../../Assest/back.png";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import apiClient from "../../apiClient";
import { useSelector } from "react-redux";
import { GETBOARDDETAILS, UPATEBOARD } from "../../apiClient/apiEndpoints";
import ShareModal from "../Modals/ShareModal";
import Board from "../Whiteboard/index.js";
import jwtEncode from "jwt-encode";
import FullScreenLoader from "../FullScreenLoader/fullScreenLoader.js";

const BoardMain = () => {
  const configData = useSelector((state) => state.configSlice);
  const userData = useSelector((state) => state.userSlice);
  const navigate = useNavigate();
  const API_URL = configData?.config?.API_URL;
  const [boardData, setBoardData] = useState({});
  const { type, id } = useParams();
  const [showShare, setShowShare] = useState(false);
  const handleCloseShare = () => {
    setShowShare(false);
  };
  const [shareMoadalData, setShareModalData] = useState();
  const [saveBtn, setSaveBtn] = useState("Save");
  const [loading, setLoading] = useState(false);
  const [fullScreenLoader, setFullScreenLoader] = useState(true);
  const [photoCount,setPhotoCount]=useState(0);
  const handleBlur = async(e) => {
    boardData.title = e.target.textContent;
    let body = {
      title: e.target.textContent,
    };
    await apiClient.put(`${API_URL}${UPATEBOARD}/${id}`, body);
  };
  // _______________________________________________________________________

  const delay = (time, func) => {
    setTimeout(() => {
      func();
    }, time);
  };

  const saveBoardRelatedInfo = async () => {
    if (boardData) {
      setLoading(true);
      setPhotoCount(e=>e+1)
      delay(900, () => {
        setSaveBtn("Saved");
        setLoading(false);
      });
      delay(2500, () => setSaveBtn("Save"));
    }
  };

  const getSingleBoardDetail = async (req) => {
    try {
      const data = await apiClient.get(`${API_URL}${GETBOARDDETAILS}/${type}/${id}`);
      if (data) {
        setBoardData(() => data);
        setFullScreenLoader(false);
      } else {
        handleBack();
      }
    } catch (error) {
      handleBack();
    }
  };

  const handleShow = () => {
    let data = {};
    data.id = id;
    data.type = type;
    setShareModalData(() => data);
    setShowShare(true);
  };

  const handleBack = () => {
    if (!userData?.token) {
      localStorage.clear();
      sessionStorage.clear();
      const payload = {
        origin: window.location.origin,
        redirectUri: window.location.pathname,
      };
      const token = jwtEncode(payload, "");
      return (window.location.href = `${configData.config.redirectUri}?referrer=${token}`);
    }
    navigate("/");
  };

  useEffect(() => {
    if (API_URL) {
      getSingleBoardDetail();
    }
  }, [API_URL]);

  return (
    <>
      {fullScreenLoader ? (
        <FullScreenLoader />
      ) : (
        <>
          <header className="main-head board-head">
            <div className="left">
              <span className="logo">
                <button className="back-arrow" onClick={() => handleBack()}>
                  {" "}
                  <img className="back-arrow" src={img} href="#" alt="" />
                </button>

                <div
                  className="input-name"
                  contentEditable
                  spellCheck="false"
                  suppressContentEditableWarning
                  onBlur={handleBlur}
                  onInput={(e) => {
                    const text = e.currentTarget.textContent;
                  }}
                  role="textbox"
                  aria-label="Rename"
                  data-tooltip="Rename"
                  tabIndex="0"
                >
                  {boardData?.title || "Untitled"}
                </div>
              </span>
            </div>
            {boardData?.allocations !== null ? (
              <div className="right ">
                <span className="share-btn">
                  {/* <button
                    disabled={boardData?.access ==='READ'}
                    id="save-btn"
                    className={loading ? " loading share  " : " share"}
                    onClick={() => saveBoardRelatedInfo()}
                  >
                    {loading ? (
                      <svg viewBox="25 25 50 50">
                        <circle r="20" cy="50" cx="50">
                          {""}
                        </circle>
                      </svg>
                    ) : (
                      saveBtn
                    )}
                  </button> */}

                  <button
                    // disabled={boardInfo?.access !== ("OWNER" || "EDIT")}
                    className={loading ? " loading share " : "share "}
                    onClick={() => handleShow()}
                  >
                    {" "}
                    Share
                  </button>
                </span>
                {showShare && (
                  <ShareModal show={showShare} onHide={handleCloseShare} shareMoadalData={shareMoadalData} />
                )}
              </div>
            ) : (
              <span className="share-btn">
                <button className="share" onClick={() => handleBack()}>
                  Login
                </button>{" "}
              </span>
            )}
          </header>
          <div>{API_URL && id && <Board title={boardData.title} photoCount={photoCount} roomId={id} access={boardData.access === "READ" ? false : true} />}</div>
        </>
      )}
    </>
  );
};
export default BoardMain;
